<template>
  <component :is="tag" ref="root" data-theme="notch" class="n-tooltip-wrapper"><slot /></component>
</template>

<script lang="ts">
import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator'
import tippy, { Instance, Props as TippyProps } from 'tippy.js'

const sizesMap = {
  s: 200,
  m: 400,
  l: 600
} as const

@Component
export default class NTooltip extends Vue {
  @Prop({ default: 'span' }) tag!: 'div' | 'span'
  @Prop({ default: true, type: Boolean }) showTooltip!: boolean
  @Prop({ default: () => ({} as TippyProps) }) tippyProps!: Partial<TippyProps>
  @Prop({ type: String, validator: (prop: keyof typeof sizesMap) => !!sizesMap[prop], default: 's' })
  private size!: keyof typeof sizesMap

  @Ref('root') rootRef!: HTMLElement

  private tippyInstance!: Instance

  mounted() {
    this.onUpdateShowTooltip()
  }

  @Watch('showTooltip')
  @Watch('tippyProps')
  onUpdateShowTooltip() {
    if (this.tippyInstance) {
      this.tippyInstance.destroy()
    }
    if (this.showTooltip) {
      this.tippyInstance = tippy(this.rootRef, {
        theme: 'notch',
        appendTo: () => document.body,
        placement: 'top',
        maxWidth: sizesMap[this.size],
        ...this.tippyProps
      })
    }
  }
}
</script>

<style scoped>
.n-tooltip-wrapper {
  display: flex;
  flex-basis: 0;
}
</style>

<style lang="scss">
@use '@/assets/styles' as *;

.tippy-box[data-theme~='notch'] {
  @include notch-text-label-light-XS;

  border: 1px solid $notch-color-neutral-grey-800;
  border-radius: $notch-radius-6x;
  padding: $notch-space-1x $notch-space-3x;

  background-color: $notch-color-neutral-grey-800;
  color: $notch-color-neutral-grey-000;

  &[data-placement^='top'] > .tippy-arrow::before {
    border-top-color: $notch-color-neutral-grey-800;
    bottom: -5px;
    left: 4px;
    border-width: 4px 4px 0;
  }
  &[data-placement^='bottom'] > .tippy-arrow::before {
    border-bottom-color: $notch-color-neutral-grey-800;
    top: -5px;
    left: 4px;
    border-width: 0 4px 4px;
  }
}
</style>
